import { Login } from '@src/main/modules/auth/ui/Login/Login';
import MessagesAddressesPage from '@src/main/modules/messages/ui/pages/MessagesAddresses';
import MessagesMailboxPage from '@src/main/modules/messages/ui/pages/MessagesMailboxPage';
import MessagesSubjectsPage from '@src/main/modules/messages/ui/pages/MessagesSubjectsPage';
import NewMessagePage from '@src/main/modules/messages/ui/pages/NewMessagePage';
import FleetAssignmentPage from '@src/main/modules/parameters/ui/pages/FleetAssignmentPage';
import FleetsAndPositionsPage from '@src/main/modules/parameters/ui/pages/FleetsAndPositionsPage';
import IssuesPage from '@src/main/modules/parameters/ui/pages/IssuesPage';
import ParametersManagementPage from '@src/main/modules/parameters/ui/pages/ParametersManagementPage';
import ReleaseNotesPage from '@src/main/modules/parameters/ui/pages/ReleaseNotesPage';
import EvaluationsPage from '@src/main/modules/reports/ui/EvaluationsPage';
import ReportsPage from '@src/main/modules/reports/ui/ReportsPage';
import PdfDownloadBridge from '@src/main/modules/reports/ui/components/PdfDownloadBridge';
import PositionAssignmentView from '@src/main/modules/reports/ui/components/PositionAssignmentView';
import RolesManagementPage from '@src/main/modules/roles/ui/pages/RolesManagementPage';
import UsersManagementPage from '@src/main/modules/user/ui/pages/UsersManagementPage';
import { PERMISSIONS } from '@src/main/shared/constants/permissions';
import { PermissionRoute } from '@src/main/shared/ui/components/PermissionRoute';
import MainLayout from '@src/main/shared/ui/layout/MainLayout';
import type React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: 'home',
        element: <MessagesMailboxPage />,
      },
      {
        path: 'parameters/positions_fleets',
        element: (
          <PermissionRoute permission={PERMISSIONS.PARAMETERS.POSITIONS_FLEETS.view}>
            <FleetsAndPositionsPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'parameters/manage_parameters',
        element: (
          <PermissionRoute permission={PERMISSIONS.PARAMETERS.MANAGE_PARAMETERS.view}>
            <ParametersManagementPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'parameters/fleet_assignment',
        element: (
          <PermissionRoute permission={PERMISSIONS.PARAMETERS.FLEET_ASSIGNMENT.view}>
            <FleetAssignmentPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'parameters/release_notes',
        element: (
          <PermissionRoute permission={PERMISSIONS.PARAMETERS.RELEASE_NOTES.view}>
            <ReleaseNotesPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'parameters/issues',
        element: (
          <PermissionRoute permission={PERMISSIONS.PARAMETERS.ISSUES.view}>
            <IssuesPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'roles-management',
        element: (
          <PermissionRoute permission={PERMISSIONS.ROLES_MANAGEMENT.view}>
            <RolesManagementPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'users-management',
        element: (
          <PermissionRoute permission={PERMISSIONS.USERS_MANAGEMENT.view}>
            <UsersManagementPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'messages/mailbox',
        element: (
          <PermissionRoute permission={PERMISSIONS.MESSAGES.MAILBOX.view}>
            <MessagesMailboxPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'messages/subjects',
        element: (
          <PermissionRoute permission={PERMISSIONS.MESSAGES.SUBJECTS.view}>
            <MessagesSubjectsPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'messages/addresses',
        element: (
          <PermissionRoute permission={PERMISSIONS.MESSAGES.ADDRESSES.view}>
            <MessagesAddressesPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'messages/new-message',
        element: (
          <PermissionRoute permission={PERMISSIONS.MESSAGES.NEW_MESSAGE.view}>
            <NewMessagePage />
          </PermissionRoute>
        ),
      },
      {
        path: 'reports',
        element: (
          <PermissionRoute permission={PERMISSIONS.REPORTS.view}>
            <ReportsPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'reports/evaluations',
        element: (
          <PermissionRoute permission={PERMISSIONS.EVALUATIONS.view}>
            <EvaluationsPage />
          </PermissionRoute>
        ),
      },
      {
        path: 'forms/:id/pdf',
        element: (
          <PermissionRoute permission={PERMISSIONS.REPORTS.view}>
            <PdfDownloadBridge type="forms" />
          </PermissionRoute>
        ),
      },
      {
        path: 'flight-evaluations/:id/pdf',
        element: (
          <PermissionRoute permission={PERMISSIONS.EVALUATIONS.view}>
            <PdfDownloadBridge type="flight-evaluations" />
          </PermissionRoute>
        ),
      },
      {
        path: 'commercial-evaluations/:id/pdf',
        element: (
          <PermissionRoute permission={PERMISSIONS.EVALUATIONS.view}>
            <PdfDownloadBridge type="commercial-evaluations" />
          </PermissionRoute>
        ),
      },
      {
        path: 'reports/positionassignment',
        element: (
          <PermissionRoute permission={PERMISSIONS.EVALUATIONS.view}>
            <PositionAssignmentView />
          </PermissionRoute>
        ),
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
]);

function Router(): React.ReactElement {
  return <RouterProvider router={router} />;
}

export { Router };
